<template>
  <div class="full-screen-type">
    <div class="title-container">
      <div class="title-wrapper">
        <h1 class="title">{{ $t(`create.step3.fullscreenType.title`) }}</h1>
        <SmallMobileIcon class="mobile-icon" />
      </div>
      <TooltipIcon
        v-tippy="{
          arrow: true,
          placement: 'right',
          a11y: false,
          boundary: 'window',
        }"
        class="tooltip-icon"
        :content="$t('create.step3.fullscreenType.tooltip')"
      />
    </div>
    <div class="buttons">
      <button
        v-if="isCarouselInline"
        class="control-btn"
        :class="{
          'control-btn-selected': isInlineSelected,
        }"
        @click="setInline"
      >
        {{ $t(`create.step3.fullscreenType.inline`) }}
      </button>
      <button
        class="control-btn"
        :class="{ 'control-btn-selected': isFittedSelected }"
        @click="setFitted"
      >
        {{ $t(`create.step3.fullscreenType.fitted`) }}
      </button>
      <button
        class="control-btn"
        :class="{
          'control-btn-selected': isImmersiveSelected,
        }"
        @click="setImmersive"
      >
        {{ $t(`create.step3.fullscreenType.immersive`) }}
      </button>
    </div>
  </div>
</template>

<script>
import SmallMobileIcon from "@/assets/svg/small-mobile-icon.svg?inline";
import TooltipIcon from "@/assets/svg/tooltip-icon-dark.svg?inline";
export default {
  components: {
    SmallMobileIcon,
    TooltipIcon,
  },
  props: {
    formatObject: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    isCarouselInline() {
      return (
        this.formatObject.formatType === 3 && !this.formatObject.isFullScreen
      );
    },
    normalizedSmallerFrame() {
      const v = this.formatObject?.isSmallerFrame;
      return typeof v === "boolean" ? v : false;
    },
    normalizedFullScreenMobile() {
      const v = this.formatObject?.isFullScreenMobile;
      return typeof v === "boolean" ? v : false;
    },
    isInlineSelected() {
      return !this.normalizedSmallerFrame && !this.normalizedFullScreenMobile;
    },
    isFittedSelected() {
      return this.isCarouselInline
        ? this.normalizedSmallerFrame && this.normalizedFullScreenMobile
        : this.normalizedSmallerFrame === true;
    },
    isImmersiveSelected() {
      return this.isCarouselInline
        ? !this.normalizedSmallerFrame && this.normalizedFullScreenMobile
        : this.normalizedSmallerFrame === false;
    },
  },
  watch: {
    isCarouselInline: {
      handler() {
        this.ensureDefaults();
      },
      immediate: true,
    },
    "formatObject.isSmallerFrame"(v) {
      if (typeof v !== "boolean") this.ensureDefaults();
    },
    "formatObject.isFullScreenMobile"(v) {
      if (this.isCarouselInline && typeof v !== "boolean")
        this.ensureDefaults();
    },
  },
  methods: {
    ensureDefaults() {
      const hasSmaller = typeof this.formatObject?.isSmallerFrame === "boolean";
      const hasMobile =
        typeof this.formatObject?.isFullScreenMobile === "boolean";

      if (this.isCarouselInline) {
        if (!hasSmaller) {
          this.$emit("change-format-object", {
            inputFor: "isSmallerFrame",
            value: false,
          });
        }
        if (!hasMobile) {
          this.$emit("change-format-object", {
            inputFor: "isFullScreenMobile",
            value: false,
          });
        }
      } else {
        if (!hasSmaller) {
          this.$emit("change-format-object", {
            inputFor: "isSmallerFrame",
            value: false,
          });
        }
      }
    },
    setInline() {
      this.$emit("change-format-object", {
        inputFor: "isSmallerFrame",
        value: false,
      });
      this.$emit("change-format-object", {
        inputFor: "isFullScreenMobile",
        value: false,
      });
    },
    setFitted() {
      this.$emit("change-format-object", {
        inputFor: "isSmallerFrame",
        value: true,
      });
      if (this.isCarouselInline) {
        this.$emit("change-format-object", {
          inputFor: "isFullScreenMobile",
          value: true,
        });
      }
    },
    setImmersive() {
      this.$emit("change-format-object", {
        inputFor: "isSmallerFrame",
        value: false,
      });
      if (this.isCarouselInline) {
        this.$emit("change-format-object", {
          inputFor: "isFullScreenMobile",
          value: true,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.full-screen-type {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  &:hover {
    background-color: $settings-hover;
  }
}
.title-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}
.title {
  @include base-font;
  @include font-small;
}

.buttons {
  display: flex;
  justify-content: center;
  width: 100%;

  .control-btn {
    align-items: center;
    background-color: transparent;
    @include base-font;
    @include font-smaller;
    display: flex;
    color: $medium-grey;
    border: 1px solid $medium-grey;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 6px 0px;
    height: 36px;
    &:hover {
      cursor: pointer;
    }
  }
  .control-btn:first-child {
    border-right: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  .control-btn:last-child {
    border-left: none;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .control-btn-selected {
    background-color: $dark-purple;
    color: white;
    border: 1px solid $dark-purple;
  }
  .disabled-btn {
    cursor: not-allowed !important;
  }
}
</style>
